import * as XLSX from 'xlsx';
import { EXCEL_TO_JSON_ERRORS } from './constants';

const excelToJson = (file, requestedSheets = [], chunkSize = 100) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = e => {
      try {
        const arrayBuffer = e.target.result;
        const workbook = XLSX.read(arrayBuffer, { type: 'array' });

        if (workbook.SheetNames.length === 0) {
          return reject({ type: EXCEL_TO_JSON_ERRORS.EMPTY_SHEETS });
        }

        const sheetData = {};

        for (const {
          header,
          maxRows,
          startRow = 0,
          requiredColumns = 0,
          renameHeaders = [],
          columnTypes = [],
        } of requestedSheets) {
          const worksheet = workbook.Sheets[header];
          if (!worksheet) continue;

          const json = XLSX.utils.sheet_to_json(worksheet, {
            defval: null,
            raw: true,
          });

          const filteredJson = json.slice(startRow);

          if (filteredJson.length > maxRows) {
            return reject({
              type: EXCEL_TO_JSON_ERRORS.MAX_BULK_ROWS,
              sheetName: header,
              rows: filteredJson.length,
              maxRows,
            });
          }

          const processedRows = [];

          for (let i = 0; i < filteredJson.length; i += chunkSize) {
            const chunk = filteredJson.slice(i, i + chunkSize);

            for (const [rowIndex, row] of chunk.entries()) {
              const columnEntries = Object.entries(row);
              if (columnEntries.length < requiredColumns) {
                return reject({
                  type: EXCEL_TO_JSON_ERRORS.EMPTY_CELLS,
                  row: startRow + i + rowIndex + 1,
                  columnCount: columnEntries.length,
                  sheetName: header,
                });
              }

              const processedRow = {};
              columnEntries.forEach(([, value], colIndex) => {
                if (renameHeaders[colIndex] === undefined) return;

                let processedValue = value;
                if (value === '' || value === null || value === undefined) {
                  return reject({
                    type: EXCEL_TO_JSON_ERRORS.EMPTY_CELLS,
                    row: startRow + i + rowIndex + 1,
                    columnCount: columnEntries.length,
                    sheetName: header,
                  });
                }

                if (columnTypes[colIndex] === 'number') {
                  if (typeof value === 'number') {
                    processedValue = parseFloat(value) || 0;
                  } else {
                    return reject({
                      type: EXCEL_TO_JSON_ERRORS.AMOUNT_TYPE,
                      row: startRow + i + rowIndex + 1,
                      columnCount: columnEntries.length,
                      sheetName: header,
                    });
                  }
                } else if (columnTypes[colIndex] === 'string') {
                  processedValue = value.toString().trim();
                }
                processedRow[
                  renameHeaders[colIndex] || `Column${colIndex + 1}`
                ] = processedValue;
              });

              processedRows.push(processedRow);

              if (processedRows.length >= maxRows) break;
            }
          }

          if (processedRows.length > 0) {
            sheetData[header] = processedRows;
          }
        }

        if (Object.keys(sheetData).length === 0) {
          return reject({ type: EXCEL_TO_JSON_ERRORS.EMPTY_SHEETS });
        }

        resolve(sheetData);
      } catch (error) {
        reject({ type: EXCEL_TO_JSON_ERRORS.READING_FILE });
      }
    };

    reader.onerror = () => {
      reject({ type: EXCEL_TO_JSON_ERRORS.READING_FILE });
    };

    reader.readAsArrayBuffer(file);
  });
};

export default excelToJson;
